import React from 'react';

const PageHeader = ({ title, subtitle, backgroundImage }) => {
  const headerStyle = backgroundImage ? {
    background: `url(${backgroundImage}?v=${Date.now()}) center/cover no-repeat`
  } : {};

  return (
    <section className="page-header" style={headerStyle}>
      <div className="page-header-content">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHeader; 